<template>
    <AModal :visible="visible" title="List Group Wilayah - Master Target SFC" @cancel="handleModalCancel"
        :destroy-on-close="true" width="70%" :footer="null">

        <AForm v-if="state.isForm" ref="formRef" class="myform" :model="form" :rules="state.rules" @finish="handleOk"
            :wrapper-col="{ span: 14 }" :scroll-to-first-error="true">

            <AFormItem label="Nama Grup Wilayah" label-align="left" :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }" name="group_wilayah_name"
                :rules="[{ required: true, message: 'Nama wajib diisi' }]">
                <AInput v-model:value="form.group_wilayah_name" placeholder="Masukkan nama grup wilayah" />
            </AFormItem>

            <!-- <AFormItem
                label="Level Wilayah"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                name="level_group"
                :rules="[{ required: true, message: 'Level wajib dipilih' }]">
                <ASelect
                    v-model:value="form.level_group"
                    placeholder="Pilih level"
                    @change="handleChangeLevel"
                >
                    <ASelectOption :value="1">Provinsi</ASelectOption>
                    <ASelectOption :value="2">Kabupaten/Kota</ASelectOption>
                    <ASelectOption :value="3">Kecamatan</ASelectOption>
                    <ASelectOption :value="4">Desa</ASelectOption>
                </ASelect>
            </AFormItem> -->

            <AFormItem label="Wilayah" label-align="left" :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }" name="wilayah_ids"
                :rules="[{ required: true, message: 'Wilayah wajib dipilih' }]">
                <FilterWilayahSemuaMultiple v-model:value="form.wilayah_ids" :disabled="!form.level_group" :placeholder="form.level_group
                    ? 'Ketik untuk mencari wilayah'
                    : 'Pilih level wilayah dulu'
                    " :level="form.level_group" :join-options="state.joinWilayahOptions" />
            </AFormItem>

            <!-- <AFormItem
                label="Wilayah"
                name="wilayah_ids"
                :rules="[{ required: true, message: 'Wilayah wajib dipilih' }]">
                <ASelect
                    v-model:value="form.wilayah_ids"
                    mode="multiple"
                    placeholder="Pilih wilayah"
                    :options="state.wilayahOptions"
                    :loading="state.loadingWilayah"
                    optionFilterProp="label"
                    show-search
                />
            </AFormItem> -->

            <ARow class="form-row mt-2">
                <ACol :sm="4" />
                <ACol :sm="20">
                    <ASpace>
                        <AButton type="primary" html-type="submit" :loading="form.busy" :disabled="form.busy">{{
                            form.id ? 'Perbarui' : 'Simpan'
                            }}</AButton>
                        <AButton title="Batal" @click="state.isForm = !state.isForm; form.reset()">Batal</AButton>
                    </ASpace>
                </ACol>
            </ARow>
        </AForm>
        <div v-else class="row justify-content-end">
            <div class="col-auto">
                <ASpace>
                    <ATooltip title="Tambahkan">
                        <AButton :loading="state.isFetching" @click="state.isForm = !state.isForm" type="primary">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </AButton>
                    </ATooltip>
                </ASpace>
            </div>
        </div>

        <div v-if="state.errors" class="mt-2">
            <ASpace>
                <AAlert v-for="(item, index) in state.errors" type="error" :key="index" :message="item" banner closable
                    @close="state.errors = []" />
            </ASpace>
        </div>

        <!-- list table -->
        <div class="table-responsive text-nowrap mt-4">
            <MdTable :columns="state.columns" :data-source="state.data" size="small"
                :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" :pagination="{
                    showSizeChanger: true,
                    pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
                    showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
                    total: state.meta.total,
                    pageSize: state.meta.per_page,
                    current: state.meta.page,
                }" @change="handleTableChange" :loading="state.isFetching">
                <template #action="{ record }">
                    <ASpace>
                        <ATooltip title="Edit">
                            <AButton class="button" size="small" @click="btnForm(record)">
                                <i class="fe fe-edit" />
                            </AButton>
                        </ATooltip>
                        <ATooltip title="Hapus">
                            <AButton class="button" size="small" :loading="record.isDelete" @click="btnDelete(record)">
                                <i class="fe fe-trash" />
                            </AButton>
                        </ATooltip>
                    </ASpace>
                </template>
            </MdTable>
        </div>
    </AModal>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import FilterWilayahSemuaMultiple from '@/components/filter/FilterWilayahSemuaMultiple'
import Form from 'vform'
import { pickBy } from 'lodash'
import {
    hasRoles,
    ROLE_ADMIN_BK,
} from '@/helpers'

export default defineComponent({
    components: {
        FilterWilayahSemuaMultiple,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
            }),
        },
    },
    emits: ['update:visible', 'success'],
    setup(props, { emit }) {
        const formRef = ref();

        const form = reactive(new Form({
            id: null,
            group_wilayah_name: '',
            level_group: 1, // null,
            wilayah_ids: [],
        }))

        const state = reactive({
            columns: [
                {
                    title: 'Nama Group Wilayah',
                    dataIndex: 'group_wilayah_name',
                },
                {
                    title: 'Wilayah',
                    dataIndex: 'wilayahs',
                    customRender: ({ text }) => {
                        if (!text || !Array.isArray(text)) return '-'

                        return text.map(w => w.name).join(', ')
                    },
                },
                {
                    title: 'Action',
                    dataIndex: 'action',
                    slots: { customRender: 'action' },
                },
            ],
            joinWilayahOptions: [],
            // wilayahOptions: [],
            // loadingWilayah: false,
            endpoint: {
                current: `/api/atsalesman/group-wilayah`,
            },
            errors: [],
            data: [],
            meta: {
                per_page: 10,
                page: 1,
                total: 0,
            },
            isFetching: false,
            params: {
                q: '',
                page: 1,
                "per-page": 10,
            },
            isForm: false,
            rules: {
            },
            errors: [],
        })

        // const handleChangeLevel = async (level) => {
        //     form.wilayah_ids = []
        //     state.joinWilayahOptions = []

        //     if (!level) return

        //     state.loadingWilayah = true

        //     try {
        //         const res = await apiClient.get('/api/filter/wilayah/${level}', {
        //             params: { q: searchText.value || null },
        //         })

        //         state.wilayahOptions = res.data.map(item => ({
        //             value: Number(item.id),
        //             label: item.name,
        //         }))
        //     } catch (err) {
        //         console.error(err)
        //     } finally {
        //         state.loadingWilayah = false
        //     }
        // }

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const handleTableChange = (page, filters, sorter) => {
            state.params.page = page.current
            state.params["per-page"] = page.pageSize

            fetchDataList()
        }

        const handleOk = async () => {
            // validation form
            await formRef.value.validate()
                .catch(() => { });

            let request = form.id
                ? form.put(`${state.endpoint.current}/${form.id}`)
                : form.post(`${state.endpoint.current}`)

            request.then(({ data }) => {
                if (data === undefined) {
                    errorMessage.value = `Kode error 500, No response from server`
                    return
                }

                if (data.success) {
                    message.success(data.message)

                    state.errors = []

                    form.reset()
                    form.clear()
                    form.id = null
                    form.level_group = 1
                    form.wilayah_ids = []

                    formRef.value.resetFields()
                    state.joinWilayahOptions = []
                    state.isForm = false

                    fetchDataList()
                    emit('success')
                    return
                }

                message.error(data.errors)
            })
                .catch(({ response: { data, status } }) => {
                    if (data) {
                        state.errors = typeof data.errors === 'object' ? Object.values(data.errors) : [data.errors]
                    }
                })

        }

        // fetch list data
        const fetchDataList = () => {
            state.isFetching = true

            apiClient
                .get(state.endpoint.current, {
                    params: pickBy(state.params),
                })
                .then(({ data }) => {
                    const { items, _meta } = data

                    items.forEach((item) => {
                        item.isDelete = false
                    })

                    state.data = items
                    state.meta.page = _meta.currentPage
                    state.meta.per_page = _meta.perPage
                    state.meta.total = _meta.totalCount
                })
                .finally(() => {
                    state.isFetching = false
                })
        }

        // btn form
        const btnForm = (item = null) => {
            state.isForm = true

            formRef.value?.resetFields()
            form.reset()
            form.clear()

            form.id = null
            form.level_group = 1
            form.wilayah_ids = []

            if (item) {
                form.id = item.id
                form.fill(item)

                // isi joinOptions supaya label muncul
                state.joinWilayahOptions = item.wilayahs || []
                form.wilayah_ids = item.wilayahs.map(w => w.id)
            }
        }

        // btn delete
        const btnDelete = (record) => {
            Modal.confirm({
                title: 'Konfirmasi Hapus',
                content: 'Apakah Anda ingin hapus item tersebut?',
                async onOk() {
                    record.isDelete = true

                    try {
                        const { data } = await apiClient.delete(`${state.endpoint.current}/${record.id}`)

                        if (!data?.success) {
                            message.error(data?.message || 'Gagal menghapus')
                            return
                        }

                        message.success(data.message)
                        fetchDataList()

                    } catch (e) {
                        const msg = e?.response?.data?.message || 'Gagal menghapus!'
                        message.error(msg)
                    } finally {
                        record.isDelete = false
                    }
                },
            })
        }

        onMounted(() => {
            fetchDataList()
        })

        return {
            fetchDataList,
            state,
            formRef,
            form,
            handleModalCancel,
            handleTableChange,
            handleOk,
            btnDelete,
            btnForm,
            // only variable role
            hasRoles,
            ROLE_ADMIN_BK,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
